import { render, staticRenderFns } from "./Curriculo_Login.vue?vue&type=template&id=c9f7a284&scoped=true"
import script from "./Curriculo_Login.vue?vue&type=script&lang=js"
export * from "./Curriculo_Login.vue?vue&type=script&lang=js"
import style0 from "./Curriculo_Login.vue?vue&type=style&index=0&id=c9f7a284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f7a284",
  null
  
)

export default component.exports